import { observer } from "mobx-react";
import {
  LocalizedMarkdownQuestion,
  LocalizedTextQuestion,
  NumberQuestion,
} from "../common/commonComponents";
import { InsertSignatureInArticlesOfAssociationForm } from "./insertSignatureInArticlesOfAssociationDomain";
import { Alert } from "../../components-v2/Alert";
import { VBox } from "../../components-v2/Box";
import { useEffect } from "react";

import { useTranslation } from "../../stores/RootStoreContext";

export const InsertSignatureInArticlesOfAssociationView = observer(
  function ChangeSignatureInArticlesOfAssociationView({
    form,
  }: {
    form: InsertSignatureInArticlesOfAssociationForm;
  }) {
    const { t } = useTranslation();

    useEffect(() => {
      form.languages.forEach((l) => {
        const title = form.titles.find((t) => t.locale === l);
        if (title && !title.model.validatedValue) {
          title.model.setAndCommitInputValue(
            t("decisions.signature.provision.insert.defaultTitle", { lang: l }),
          );
        }
      });
    }, [form, t]);

    return (
      <VBox gap={"md"}>
        <VBox>
          <NumberQuestion
            question={t("decisions.signature.provision.insert")}
            field={form.paragraph}
            isLocked={form.isProjectLocked}
          />
          <Alert type="info" message={t("decisions.signature.provision.insert.helperText")} />
        </VBox>
        <LocalizedTextQuestion
          question={t("decisions.signature.provision.insert.title")}
          name={"article-title"}
          textModels={form.titles}
          isLocked={form.isProjectLocked}
        />
        <LocalizedMarkdownQuestion
          question={t("decisions.signature.provision.insert.text")}
          name={"article-text"}
          textModels={form.texts}
          isLocked={form.isProjectLocked}
        />
      </VBox>
    );
  },
);
